
import '../../css/AnnouncementSection.css';
// ✅ image imports
import img1 from "../../../assets/announcement/image3.jpeg";
import img2 from "../../../assets/announcement/image5.webp";
import img3 from "../../../assets/announcement/image4.jpeg";

import tickWhite from "../../../assets/announcement/tick.png";
import tickBlack from "../../../assets/announcement/b-tick.png";

export default function AnnouncementSection() {
  const sections = [
    {
      bg: "blue-bg",
      text: "text-white",
      heading: "Test Smarter",
      features: [
        "Monitor progress and change your testing plan immediately",
        "Be updated with changes and modify your QA flow instantly",
        "Keep testing regularly, fixing defects quickly",
      ],
      img: img1,
      tick: tickWhite,
      reverse: false,
    },
    {
      bg: "white-bg",
      text: "text-dark",
      heading: "Collaboration, Redefined",
      features: [
        "Ensure that your team members are always updated with each other through a smooth organizational structure",
        "Responsibility and access levels can be easily and clearly defined",
        "Adapt your QA process to fit your team’s manner",
      ],
      img: img2,
      tick: tickBlack,
      reverse: true,
    },
    {
      bg: "blue-bg",
      text: "text-white",
      heading: "Maintain Agility",
      features: [
        "Monitor the performance of the project with a single view of coverage, speed, and issues",
        "Once built, reuse as much as you want—save tests as templates",
        "On the go, manage your projects with a feature-rich mobile experience and live ​‍​‌‍​‍‌​‍​‌‍​‍‌dashboard",
      ],
      img: img3,
      tick: tickWhite,
      reverse: false,
    },
  ];

  return (
    <section className="announcement-section text-center">

      {/* Heading */}
      <h2 className="main-title">
        <span>Froth TestOps</span>: Where simplified QA testing becomes your new normal
      </h2>

      <p className="sub-text">
        Everything you need to excel—packed into one intuitive platform that just works.
Effortless. Powerful. Exactly what QA teams deserve.
      </p>

      {sections.map((sec, idx) => (
        <div className={`${sec.bg} ${sec.text} py-5`} key={idx}>
          <div className="container">

            <div className="row align-items-center">

              {/* LEFT IMAGE */}
              {!sec.reverse && (
                <div className="col-lg-7 mb-4 mb-lg-0">
                  <img src={sec.img} className="img-fluid rounded shadow" />
                </div>
              )}

              {/* TEXT */}
              <div className="col-lg-5 text-start">
                <h3 className="section-heading">{sec.heading}</h3>

                <ul className="list-unstyled">
                  {sec.features.map((item, i) => (
                    <li key={i} className="d-flex align-items-start mb-3">
                      <img src={sec.tick} className="tick-icon" />
                      <span className="features-text">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* RIGHT IMAGE */}
              {sec.reverse && (
                <div className="col-lg-7 mt-4 mt-lg-0">
                  <img src={sec.img} className="img-fluid rounded shadow" />
                </div>
              )}

            </div>

          </div>
        </div>
      ))}
    </section>
  );
}